import React from "react";
import { animated } from "react-spring";

export default ({ style }) => {
  return (
    <animated.div className="Loading" style={style}>
      <div className="Loading-inner">...Loading</div>
    </animated.div>
  )
}